import type ErrorTracking from '@socialtechnologies/error-tracking-lib'

class ErrorTrackingService {
  private errorTracking: typeof ErrorTracking | null = null

  async init(...parameters: Parameters<typeof ErrorTracking['init']>): Promise<void> {
    this.errorTracking = (await import('@socialtechnologies/error-tracking-lib')).default

    return this.errorTracking.init(...parameters)
  }

  activateTracking(...parameters: Parameters<typeof ErrorTracking['activateTracking']>): void {
    if (!this.errorTracking) {
      return
    }

    return this.errorTracking.activateTracking(...parameters)
  }

  activateReplay(...parameters: Parameters<typeof ErrorTracking['activateReplay']>): Promise<void> {
    if (!this.errorTracking) {
      return Promise.resolve()
    }

    return this.errorTracking.activateReplay(...parameters)
  }

  captureMessage(...parameters: Parameters<typeof ErrorTracking['captureMessage']>): void {
    if (!this.errorTracking) {
      return
    }

    return this.errorTracking.captureMessage(...parameters)
  }
}

export default new ErrorTrackingService()
